import RpcService       from '@/core/services/Rpc/RpcService';
import type RpcResponse from '@/core/services/Rpc/RpcResponse';

class SWPortalTasksDAO {

    static async get(id?: number, transportOrderId?: number): Promise<RpcResponse> {
        return await RpcService.makeRequest('SWPortalTasks.get', { id, transportOrderId });
    }

    static async add(task: any): Promise<RpcResponse> {
        return await RpcService.makeRequest('SWPortalTasks.add', { task });
    }
}

export default SWPortalTasksDAO;
